import { Typo3SectionSpotSanityContentGallery } from '@/types/typo3'

const toSectionGallery = (section: Typo3SectionSpotSanityContentGallery) => ({
  section: section,
  sectionHeaderData: {
    title: section?.content?.title,
    titleLayout: section?.content?.titleLayout
  },
  images: section?.content?.images
})

export default toSectionGallery
